import React, {useEffect, useRef, useState, Suspense} from 'react'
import Loadable from 'react-loadable'

import 'lazysizes'
import 'lazysizes/plugins/attrchange/ls.attrchange'

import {Box} from './styles'
import {useCurrentPageActions, useCurrentPageAPI} from '../../features/getCurrentPage'
import {useLanguagesActions, useLanguagesAPI, useAboutContentActions, useAboutContentAPI} from '../../features/getLangs'
// import {useCityAliasActions, useCityAliasAPI} from '../../features/getCityAlias'
import Loading from '../Loading'
// import {_query} from '../../utils/query'
import {popupTicketLinks} from '../../utils/popup-ticket-links'
import '../../utils/embla-carousel-methods'

import {useCoordsActions, useCoordsAPI} from '../../features/getCoords'
import getUrlParameter from '../../utils/getUrlParameter'

const threeBtnVersion = getUrlParameter('threeBtn') === '1'
const brandTheme = threeBtnVersion ? 'BrandArea' : 'BrandArea/BrandArea'
export const ThreeBtnContext = React.createContext()

const BrandArea = Loadable({
  loader: () => import(`../BrandArea`),
  loading: Loading,
})
const Notice = Loadable({
  loader: () => import(`../Notice`),
  loading: Loading,
})
const PopupLocateCity = Loadable({
  loader: () => import(`../Notice/PopupLocateCity`),
  loading: Loading,
})
const SubscriptionStatus = Loadable({
  loader: () => import(`../Notice/SubscriptionStatus`),
  loading: Loading,
})
const ModalVideoFrame = Loadable({
  loader: () => import(`../ModalVideoFrame`),
  loading: Loading,
})
const GetReviewsVideo = Loadable({
  loader: () => import(`../BrandArea/GetReviewsVideo`),
  loading: Loading,
})
const HeaderBarMobile = Loadable({
  loader: () => import('../HeaderBarMobile'),
  loading: Loading,
})
const About = Loadable({
  loader: () => import('../About'),
  loading: Loading,
})
const FlowChart = Loadable({
  loader: () => import('../FlowChart'),
  loading: Loading,
})

Object.assign(window.lazySizes.cfg, {
  loadHidden: false,
  hFac: 0.5,
  expFactor: 1.5,
  loadMode: 0,
  ricTimeout: 150,
  lazyClass: 'Image--lazyLoad',
  loadedClass: 'Image--lazyLoaded',
  loadingClass: 'lazy-loading',
  customMedia: {
    '--small': '(max-width: 480px)',
    '--medium': '(max-width: 767px)',
    '--mediumup': '(min-width: 768px)',
    '--large': '(max-width: 1024px)',
    '--xlarge': '(min-width: 1280px)',
  },
})

const App = () => {
  const [isLoaded, setLoaded] = useState(false)

  const {currentPage, currentEnv} = useCurrentPageAPI()
  const {getCurrentPage, getCurrentEnv} = useCurrentPageActions()

  const {langs, fulfilledLangs} = useLanguagesAPI()
  const {getLanguages} = useLanguagesActions()

  const {content, fulfilledContent} = useAboutContentAPI()
  const {getContent} = useAboutContentActions()

  // const {cityAliasOrGroup, fulfilledAlias} = useCityAliasAPI()
  // const {getCityAliasOrGroup} = useCityAliasActions()

  const {setCoords} = useCoordsActions()
  const {coords, fulfilledCoords} = useCoordsAPI()

  // const dev = process.env.NODE_ENV === 'development'
  // const cityPage = currentPage === 'cityPage'
  // const dev = currentEnv

  useEffect(() => {
    if (currentPage === '') {
      getCurrentPage()
      getCurrentEnv()
      // console.debug(`currentEnv: ${currentEnv}`)
      // setFetchedLang(true)
    }
  })

  useEffect(() => {
    if (!fulfilledLangs) {
      getLanguages()
      // setFetchedLang(true)
    }
  }, [fulfilledLangs, getLanguages])

  useEffect(() => {
    if (currentPage === 'homePage' && !fulfilledCoords) {
      setCoords()
    }
  }, [coords, currentPage, fulfilledCoords, setCoords])

  // useEffect(() => {
  //   if (!fulfilledAlias) {
  //     if (currentPage === 'homePage') {
  //       if (fulfilledCoords) getCityAliasOrGroup(coords)
  //     }
  //   }
  // }, [coords, currentPage, fulfilledAlias, fulfilledCoords, getCityAliasOrGroup, setCoords])

  useEffect(() => {
    if (!fulfilledContent) {
      getContent()
      // setFetchedLang(true)
    }
  }, [fulfilledContent, getContent])

  useEffect(() => {
    // if (currentPage === '') setLoaded(false)
    if (fulfilledLangs && fulfilledContent) {
      setLoaded(true)
    }
    // if (currentPage === 'homePage') {
    //   if (fulfilledLangs && fulfilledAlias) {
    //     setLoaded(true)
    //   }
    // } else if (fulfilledLangs) {
    //   setLoaded(true)
    // }
  }, [fulfilledContent, fulfilledLangs])

  // useEffect(() => {
  //   if (!dev) {
  //     const div = _query('.ArticleSeo__PlaceHolder')
  //     if (div !== null) {
  //       const CityGroupAbout = div.innerHTML
  //       if (CityGroupAbout !== '') {
  //         div.innerHTML = ''
  //       }
  //     }
  //   }
  // })

  // if (!isLoaded) {
  //   return (
  //     <Box className="rootWrapper">
  //       {/*<BrandArea />*/}
  //       <Loading />
  //     </Box>
  //   )
  // }
  // return <Loading />

  return (
    <Suspense fallback={<Loading background="rgba(255,255,255, 0.5)" />}>
      <>
        <Box className={`rootWrapper ${langs.loginLangCode}`}>
          {isLoaded && <HeaderBarMobile />}
          <ThreeBtnContext.Provider value={{loginLangCode: langs.loginLangCode}}>
            <BrandArea />
          </ThreeBtnContext.Provider>
          <>
            {isLoaded && (
              <>
                <About aboutContent={content} />
                <FlowChart />
              </>
            )}
          </>
        </Box>
        {isLoaded && (
          <>
            <GetReviewsVideo />
            <ModalVideoFrame />
            <Notice />
            <PopupLocateCity />
            <SubscriptionStatus />
          </>
        )}
      </>
    </Suspense>
  )
}

export default App
